import { type ExternalEntity } from '@/types';
import { makeRequestActionCreator } from '@/utils';
import { sportsSlice } from './slice';

const createRequestAction = makeRequestActionCreator(sportsSlice.name);

export const tryFetchSports = createRequestAction<void, ExternalEntity[]>(
  'tryFetchSports',
);

export const fetchSports = createRequestAction<void, ExternalEntity[]>(
  'fetchSports',
);

export const { setSports } = sportsSlice.actions;
